<template>
  <b-container v-if="sales_products_context_loaded" fluid>
    <b-row style="justify-content: center;" class="mb-3">
      <b-form-input
        class="sku-input"
        v-model="skuInput"
        placeholder="Digite o sku para destacar na tabela"
      />
    </b-row>
    <b-row>
      <b-col lg="6" sm="12" class="mb-4">
        <b-row>
          <b-col class="white-box mr-2 ml-2">
            <b-row class="table-header">
              <b-col class="text-base" style="text-align: center;">
                <img class="d-inline-block align-middle" src="@/assets/calendar_icon.svg" alt="calendar_icon">&nbsp;&nbsp;
                <span class="d-inline-block align-middle">{{ previous_month_name }}</span>
              </b-col>
            </b-row>
            <!-- https://bootstrap-vue.js.org/docs/components/table -->
            <b-row class="m-0">
              <b-table
                id="previous-items-table"
                class="text-base text-12"
                style="color: #666666;"
                :items="previous_items"
                :fields="fieldsPrevious"
                ref="selectableTablePrevious"
                selectable
                responsive
                select-mode="multi"
                selected-variant="success"
                @row-selected="onRowSelected"
                @sort-changed="selectTableRow"
                @row-dblclicked="onRowDoubleClicked"
                head-variant="light" striped hover/>
            </b-row>
          </b-col>
        </b-row>
      </b-col>
      <b-col lg="6" sm="12" class="mb-4">
        <b-row>
          <b-col class="white-box mr-2 ml-2">
            <b-row class="table-header">
              <b-col class="text-base" style="text-align: center;">
                <img class="d-inline-block align-middle" src="@/assets/calendar_icon.svg" alt="calendar_icon">&nbsp;&nbsp;
                <span class="d-inline-block align-middle">{{ current_month_name }}</span>
              </b-col>
            </b-row>
            <b-row class="m-0 overflow-auto">
              <b-table
                id="current-items-table"
                class="text-base text-12"
                style="color: #666666;"
                :items="current_items"
                :fields="fieldsCurrent"
                ref="selectableTableCurrent"
                selectable
                select-mode="multi"
                selected-variant="success"
                @row-selected="onRowSelected"
                @sort-changed="selectTableRow"
                @row-dblclicked="onRowDoubleClicked"
                head-variant="light" striped hover/>
            </b-row>
          </b-col>
        </b-row>
      </b-col>
    </b-row>
    <info-icon style="margin-left: -7px; margin-top: -13px" info="Duplo clique para seguir o link para o produto"></info-icon>
  </b-container>
  <loader-box v-else height="975px" class="mr-2 mb-2 ml-2"/>
</template>

<script>
import LoaderBox from '@/components/LoaderBox.vue'
import InfoIcon from '@/components/InfoIcon.vue'

export default {
  components: {
    LoaderBox,
    InfoIcon
  },
  data: () => ({
    skuInput: '',
    fieldsPrevious: [
      {
        key: 'enumerate',
        label: ''
      }, {
        key: 'sku',
        label: 'sku'
      }, {
        key: 'qtde',
        label: 'qtde venda'
      }, {
        key: 'avg_price',
        label: 'média de preço'
      }, {
        key: 'total_sold',
        label: 'total vendido'
      }
    ],
    fieldsCurrent: [
      {
        key: 'enumerate',
        label: ''
      }, {
        key: 'sku',
        label: 'sku'
      }, {
        key: 'variation',
        label: 'diferença'
      }, {
        key: 'qtde',
        label: 'qtde venda'
      }, {
        key: 'avg_price',
        label: 'média de preço'
      }, {
        key: 'total_sold',
        label: 'total vendido'
      }
    ]
  }),
  computed: {
    sales_products_context_loaded() { return this.$store.getters.sales_products_context_loaded },
    previous_month_name() { return this.$store.getters.previous_month_name },
    current_month_name() { return this.$store.getters.current_month_name },
    previous_items() {
      return this.$store.getters.previous_items
    },
    current_items() { return this.$store.getters.current_items },
  },
  methods: {
    onRowSelected(items) {
      this.selected = items
    },
    onRowDoubleClicked(item) {
      // No momento não consegui por um reverse aqui tbm
      window.open(this.$store.getters.baseUrl + '/shoppub-v2/produtos/produto/?q=' + item.sku + '&tipo_produto_exibicao=1', '_blank');
    },
    selectTableRow(ctx, input) {
      // Não é possível haver duas referências com o mesmo nome por isso
      // o código foi duplicado,
      // TODO: Melhorar o codigo para tirar a duplicidade

      const SELECTABLE_TABLE_PREVIOUS = this.$refs.selectableTablePrevious;
      let skuRowPrevArray = [];
      let tablePrev = document.querySelector('#previous-items-table');
      let r = 0, n = tablePrev.rows.length;
      for (; r < n; r++) {
        let value_1 = tablePrev.rows[r].cells[1].innerHTML;
        if (input && value_1.toLowerCase().startsWith(input.toLowerCase())) {
          skuRowPrevArray.push(r - 1)
        }
      }
      if (skuRowPrevArray.length > 0) {
        SELECTABLE_TABLE_PREVIOUS.clearSelected()
        skuRowPrevArray.forEach(function (rowIndex) {
          SELECTABLE_TABLE_PREVIOUS.selectionHandler(null, rowIndex, null)
        });
      } else {
        SELECTABLE_TABLE_PREVIOUS.clearSelected()
      }

      const SELECTABLE_TABLE_CURRENT = this.$refs.selectableTableCurrent;
      let skuRowCurrArray = [];
      let tableCurr = document.querySelector('#current-items-table');
      let o = 0, m = tableCurr.rows.length;
      for (; o < m; o++) {
        let value_2 = tableCurr.rows[o].cells[1].innerHTML;
        if (input && value_2.toLowerCase().startsWith(input.toLowerCase())) {
          skuRowCurrArray.push(o - 1)
        }
      }
      if (skuRowCurrArray.length > 0) {
        SELECTABLE_TABLE_CURRENT.clearSelected()
        skuRowCurrArray.forEach(function (rowIndex) {
          SELECTABLE_TABLE_CURRENT.selectionHandler(null, rowIndex, null)
        });
      } else {
        SELECTABLE_TABLE_CURRENT.clearSelected()
      }
    },
    applyTableStyles() {
      setTimeout(() => {
        let tableCurr = document.querySelector('#current-items-table');
        if (tableCurr) {
          let r = 0, n = tableCurr.rows.length;
          for (; r < n; r++) {
            let c = 0, m = tableCurr.rows[r].cells.length;
            for (; c < m; c++) {
              if (tableCurr.rows[r].cells[2].innerHTML > 0)
                tableCurr.rows[r].cells[2].setAttribute("class", 'table-increment');
              if (tableCurr.rows[r].cells[2].innerHTML < 0)
                tableCurr.rows[r].cells[2].setAttribute("class", 'table-decrement');
            }
          }
        }
      }, 2000);
    }
  },
  mounted() {
    this.applyTableStyles();
  },
  watch: {
    skuInput(input) {
      this.skuInput = input;
      this.selectTableRow(null, input)
    }
  }
}
</script>

<style scoped>
  .table-header {
    align-items: center;
    justify-content: center;
    height: 50px;
  }
</style>
